import styled from 'styled-components'

export const Outer = styled.div`
  padding: 8px;
  margin: 8px 0;
`
